import { REACT_QUERY_KEYS } from '@/constants'

import {
  type FetchMonthlyCustomerReportDailyReportDetailsQuery,
  type FetchMonthlyCustomerReportHiddenChargesQuery,
  type FetchMonthlyCustomerReportQuery
} from './api'

export const monthlyCustomerReportsQueryKeys = {
  all: [REACT_QUERY_KEYS.MONTHLY_CUSTOMER_REPORTS] as const,
  detail: (query: FetchMonthlyCustomerReportQuery) => [
    ...monthlyCustomerReportsQueryKeys.all,
    'detail',
    query
  ],
  dailyReportDetailList: (
    query: FetchMonthlyCustomerReportDailyReportDetailsQuery
  ) =>
    [
      ...monthlyCustomerReportsQueryKeys.all,
      'dailyReportDetailList',
      query
    ] as const,
  hiddenChargeList: (query: FetchMonthlyCustomerReportHiddenChargesQuery) =>
    [...monthlyCustomerReportsQueryKeys.all, 'hiddenChargeList', query] as const
}
